<template>
  <!-- Error State -->
  <div
    v-if="error"
    class="error-state"
  >
    <p>{{ error }}</p>
  </div>

  <!-- Brands Slider -->
  <div
    v-if="!loading && !error && brands.length > 0"
    ref="splideContainer"
    class="splide brands__slider"
  >
    <div class="splide__track">
      <ul class="splide__list">
        <li
          v-for="brand in brands"
          :key="brand.brand_id"
          class="splide__slide brands__slider__slide"
        >
          <a
            :href="`/searchbrand?querybrand=${brand.brand_id}&name=${
              encodeURIComponent(brand.name)
            }`"
            :title="brand.name"
            class="brands__slider__slide__item"
          >
            <img
              :src="brand.image_path"
              :alt="brand.name"
            >
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- No Brands Available -->
  <div
    v-if="!loading && !error && brands.length === 0"
    class="no-brands"
  >
    <p>No brands available</p>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';

export default {
  name: 'BrandsModule',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      brands: [],
      loading: false,
      error: null,
      splideInstance: null,
    };
  },

  mounted() {
    if (this.data.brands_id) {
      this.fetchBrands();
    }
  },

  beforeUnmount() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
    }
  },

  methods: {
    fetchBrands() {
      if (!this.data.brands_id) return;

      this.loading = true;
      this.error = null;

      $.ajax({
        type: 'post',
        url: '/ajax/merchandising',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        data: {
          groupBrandMerchandising_ids: [this.data.brands_id],
        },
        timeout: 30000,
        success: (response) => {
          this.loading = false;
          this.brands = response.data?.brandmerchandising?.[this.data.brands_id] || [];
          this.$nextTick(() => this.initSplide());
        },
        error: (xhr, status, error) => {
          this.loading = false;
          this.error = `Error loading brands: ${status} - ${error}`;
          this.brands = [];
        },
      });
    },

    initSplide() {
      if (this.splideInstance) {
        this.splideInstance.destroy();
      }

      const slideCount = this.brands.length;
      if (this.brands.length === 0 || !this.$refs.splideContainer) return;

      const config = {
        type: 'loop',
        perPage: 9,
        perMove: 1,
        gap: 56,
        arrows: false,
        pagination: false,
        drag: slideCount > 9,
        height: '112px',
        autoplay: true,
        interval: 1500,
        pauseOnHover: true,
        speed: 800,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        breakpoints: {
          1920: {
            perPage: 7,
            drag: slideCount > 7,
          },
          1469: {
            perPage: 6,
            drag: slideCount > 6,
          },
          1200: {
            perPage: 5,
            drag: slideCount > 5,
          },
          900: {
            perPage: 4,
            drag: slideCount > 4,
          },
          600: {
            perPage: 3,
            drag: slideCount > 3,
          },
          500: {
            perPage: 2,
            drag: slideCount > 2,
          },
        },
      };

      this.splideInstance = new Splide(this.$refs.splideContainer, config);
      this.splideInstance.mount();
    },

  },
};
</script>
